// @vue/component
export default {
  name: 'ConversationListBox',
};
